import { api } from './api';

// pkg:calls https://swagger.launchmobility.io/backend#get_access_device_base
export const fetchAccessDevices = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });

  return api.get('/access_device', params, options);
};

// pkg:calls https://swagger.launchmobility.io/backend#get_access_device_by_id
export const fetchAccessDeviceById = (id) => {
  return api.get(`/access_device/${id}`);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_access_device_base
export const createAccessDevice = (payload) => {
  return api.post(`/access_device`, payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#put_access_device_by_id
export const updateAccessDevice = (id, payload) => {
  return api.put(`/access_device/${id}`, payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#delete_access_device_by_id
export const deleteAccessDevice = (id) => {
  return api.delete(`/access_device/${id}`);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_access_device_assign
export const assignAccessDevice = (payload) => {
  return api.post('/access_device/assign', payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_access_device_unassign
export const unassignAccessDevice = (payload) => {
  return api.post('/access_device/unassign', payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_set_get_access_device_broker
export const addBrokerToAccessDevice = (id, payload) => {
  return api.post(`/access_device/${id}/broker`, payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#delete_get_edit_vehicle_broker_by_id
export const removeBrokerFromAccessDevice = (id, broker) => {
  return api.delete(`/access_device/${id}/broker/${broker}`);
};
